import React from "react";
import "./Staffing.less";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import StaffingReportWidget from "./StaffingReportWidget/StaffingReportWidget";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import SliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import { Chip } from "@material-ui/core";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { kpiRadioSlider } from "../../../utils/helper";
import { standardDateFormat } from "../../../constants/appConstants";
class Staffing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyIdMultiple"),
      startDate: moment(localStorage.getItem("selectedendDate"))
        .startOf("month")
        .format("L"),
      endDate: moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("L"),
      selectedPropertyAbbr:
        localStorage.getItem("Abbreviation") != null
          ? localStorage.getItem("Abbreviation").split(",")
          : [],
      selectedDatacenterNames:
        localStorage.getItem("selectedPropertyIdMultipleNames") != null
          ? localStorage.getItem("selectedPropertyIdMultipleNames").split(",")
          : [],
      isChangedDC: false
    };
    localStorage.setItem(
      "selectedstartDate",
      moment(localStorage.getItem("selectedendDate"))
        .startOf("month")
        .format("L")
    );
  }

  componentDidMount() {
    const { datacenterList, endDate } = this.state;
    if (datacenterList == undefined) {
      this.getDataCenterList();
    }
    const endOfMonth = moment()
      .endOf("month")
      .format("L");

    if (moment(endOfMonth) > moment(endDate)) {
      /* empty */
    } else {
      const startDate = moment()
        .startOf("month")
        .format("L");
      const endDate = moment()
        .endOf("month")
        .format("L");

      localStorage.setItem("selectedstartDate", startDate);
      localStorage.setItem("selectedendDate", endDate);
      localStorage.setItem("MTDDefault", moment().format("MM"));
      localStorage.setItem("DateRadioSelect", "MTD");
      this.setState({ startDate: startDate, endDate: endDate });
    }
  }

  /** data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList
        });
      }
    );
  };

  /** call on text field change */
  _handleTextFieldChange = e => {
    const input = e;
    const output = moment(input, "YYYY-MM");

    localStorage.setItem(
      "selectedstartDate",
      output.startOf("month").format("L")
    );
    localStorage.setItem("selectedendDate", output.endOf("month").format("L"));
    this.setState({
      startDate: output.startOf("month").format("L"),
      endDate: output.endOf("month").format("L")
    });
  };

  /** cal on property selection */
  onPropertySelect = (id, selectedDatacenterNames, abbr) => {
    const idList = id.toString();
    localStorage.setItem("selectedPropertyIdMultiple", id);
    const { isChangedDC } = this.state;
    this.setState({
      selectedPropertyId: idList,
      selectedDatacenterNames: selectedDatacenterNames,
      selectedPropertyAbbr: abbr,
      isChangedDC: !isChangedDC
    });
  };

  handelDateChangesSlideDate = (start, end) => {
    this.setState({ startDate: start, endDate: end });
  };

  /** call on abbreviation delete click */
  abbreviationHandleDelete = value => {
    const {
      selectedPropertyId,
      selectedDatacenterNames,
      selectedPropertyAbbr,
      datacenterList
    } = this.state;

    let propertyIDToRemove = selectedPropertyId.split(",");
    if (propertyIDToRemove.length == 1) {
      ShowToast(
        "You cannot deselect all the Data Centers.",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }
    let propertyNameToRemove = selectedDatacenterNames;
    let propertyAbToRemove = selectedPropertyAbbr;
    const obj = datacenterList.find(o => o.abbreviation === value);

    propertyIDToRemove = propertyIDToRemove.filter(function(item) {
      return item != obj.propertyID;
    });

    propertyNameToRemove = propertyNameToRemove.filter(function(item) {
      return item !== obj.name;
    });

    propertyAbToRemove = propertyAbToRemove.filter(function(item) {
      return item !== value;
    });

    localStorage.setItem(
      "selectedPropertyIdMultiple",
      propertyIDToRemove.toString()
    );
    localStorage.setItem(
      "selectedPropertyIdMultipleNames",
      propertyNameToRemove.toString()
    );
    localStorage.setItem("Abbreviation", propertyAbToRemove.toString());
    const { isChangedDC } = this.state;
    this.setState({
      selectedPropertyId: propertyIDToRemove.join(","),
      selectedDatacenterNames: propertyNameToRemove,
      selectedPropertyAbbr: propertyAbToRemove,
      isChangedDC: !isChangedDC
    });
  };

  render() {
    const {
      datacenterList,
      selectedPropertyId,
      startDate,
      isChangedDC,
      selectedPropertyAbbr,
      endDate
    } = this.state;
    return (
      <Grid container>
        <Grid item xs={12}>
          <div className={"staffing-container reports-body"}>
            <Grid container>
              <Grid item className={"reports-row-one"} xs={12} sm={5} lg={5}>
                <Box className={" reports-dcList"} pl={1} pt={2} pb={2}>
                  <DatacenterList
                    dataSource={datacenterList}
                    onPropertySelect={this.onPropertySelect}
                    selectedPropertyId={selectedPropertyId}
                    classTitle={"dc-list-reports"}
                    SeType={"MultipleMaterial"}
                    isChangedDC={isChangedDC}
                  />
                </Box>
              </Grid>

              <Grid
                item
                className={"reports-row-one"}
                xs={12}
                sm={7}
                lg={7}
                justifyContent={"flex-end"}
              >
                <SliderDatePicker
                  handelDateChangesSlideDate={this.handelDateChangesSlideDate}
                  showOnly={"staffing"}
                  style={{ width: "100%" }}
                  radioSlider={kpiRadioSlider}
                  selectedDate={moment().format(standardDateFormat)}
                />
                {/* </Box> */}
              </Grid>
              <Grid xs={12} className={"dataCenter-list-div common-colour"}>
                <b>{"Selected Data Centers:"}</b>{" "}
                {selectedPropertyAbbr.map(value => (
                  <Chip
                    label={value}
                    onDelete={() => this.abbreviationHandleDelete(value)}
                    variant={"outlined"}
                    style={{ marginLeft: "4px" }}
                    className={"common-colour"}
                  />
                ))}
              </Grid>
              <Grid item xs={12}>
                <StaffingReportWidget
                  startDate={startDate}
                  endDate={endDate}
                  propertyId={selectedPropertyId}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default Staffing;
